import React, { ReactNode } from 'react';

import clsx from '../clsx';

import styles from './Stats.module.scss';

interface StatsProps {
  children: ReactNode;
  listClassName?: string;
}

const Stats = ({ children, listClassName }: StatsProps) => (
  <ul className={clsx(styles.listStats, listClassName)}>
    {React.Children.map(
      children,
      (child, index) => (child && <li key={index}>{child}</li>) || ''
    )}
  </ul>
);

export default Stats;
